import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcNotificationFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.001 2.25c4.193 0 7.556 3.49 7.556 7.75v3.809l1.29 2.35a1.75 1.75 0 0 1-1.535 2.591H4.691a1.75 1.75 0 0 1-1.534-2.592l1.289-2.35V10c0-4.26 3.363-7.75 7.555-7.75M15.784 19.75A4.31 4.31 0 0 1 12 21.995a4.31 4.31 0 0 1-3.783-2.245z"
  }));
}
var IcNotificationFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcNotificationFill));

export { IcNotificationFill as I };
